import CrewTraining from '../../Crewing/CrewFormTabs/CrewTraining'
export default CrewTraining
